import translate from '@translate';
import { HistoryUpdatesItemType } from 'src/components/History/types';
import { TableColumnType } from 'src/types/table';
import { OrderPalletType } from 'src/types/order';

export type EditKeysType =
    | 'INVOICE_DATE'
    | 'INVOICE_NUMBER'
    | 'PRICE'
    | 'SHIPPING_PRICE'
    | 'CURRENCY'
    | 'PAYMENT_METHOD'
    | 'COD_PRICE'
    | 'COD_CURRENCY'
    | 'COD_REF_NUMBER'
    | 'ESHOP_ORDER_ID'
    | 'ORDER_TYPE'
    | 'MESSAGE'
    | 'STATUS'
    | 'RELEASE_FROM_SUSPENDED_AT'
    | 'MARKETPLACE'
    | 'PAID'
    | 'PRINT_FILES'
    | 'ALLOW_EXPEDITION'
    | 'SHIPPER'
    | 'SHIPPER_SERVICE_CODE'
    | 'ADDRESS_ID'
    | 'TRACKING_NUMBER'
    | 'RETURN_TRACKING_NUMBER'
    | 'EXCHANGE_TRACKING_NUMBER'
    | 'ORDER_BOX_COUNT'
    | 'BRANCH_ID'
    | 'NOTE'
    | 'ESHOP_NOTE'
    | 'TRANSPORT_PAID_BY_SKLADON'
    | 'UNDER_SANCTION'
    | 'RECIPIENT_NAME'
    | 'RECIPIENT_ATTENTION_NAME'
    | 'RECIPIENT_STREET'
    | 'RECIPIENT_EMAIL'
    | 'RECIPIENT_PHONE'
    | 'RECIPIENT_CITY'
    | 'RECIPIENT_POST_CODE'
    | 'RECIPIENT_STATE'
    | 'RECIPIENT_PROVINCE_CODE'
    | 'RECIPIENT_ADDRESS_ADDITIONAL_INFO'
    | 'RECIPIENT_COMPANY_NAME'
    | 'RECIPIENT_GLN'
    | 'RECIPIENT_COMPANY_ID'
    | 'RECIPIENT_TAX_ID'
    | 'BILLING_NAME'
    | 'BILLING_ATTENTION_NAME'
    | 'BILLING_STREET'
    | 'BILLING_EMAIL'
    | 'BILLING_PHONE'
    | 'BILLING_CITY'
    | 'BILLING_POST_CODE'
    | 'BILLING_STATE'
    | 'BILLING_PROVINCE_CODE'
    | 'BILLING_ADDRESS_ADDITIONAL_INFO'
    | 'BILLING_COMPANY_NAME'
    | 'BILLING_GLN'
    | 'BILLING_COMPANY_ID'
    | 'BILLING_TAX_ID'
    | 'CANCEL_REASON'
    | 'PRINT_RETURN_LABEL'
    | 'HOLD_BY_QUALITY'
    | 'PICK_FROM_CUSTOMS_WAREHOUSE'
    | 'ORDER_PRODUCTS'
    | 'FILES'
    | 'REQUIRED_EXPEDITION_DATE'
    | 'DISABLE_SHIPPING_REORDER'
    | 'ORDER_PALLETS'
    | 'PREORDER_RELEASE_AT'

export const EDIT_KEYS = [
    'INVOICE_DATE',
    'INVOICE_NUMBER',
    'PRICE',
    'SHIPPING_PRICE',
    'CURRENCY',
    'PAYMENT_METHOD',
    'COD_PRICE',
    'COD_CURRENCY',
    'COD_REF_NUMBER',
    'ESHOP_ORDER_ID',
    'ORDER_TYPE',
    'MESSAGE',
    'STATUS',
    'RELEASE_FROM_SUSPENDED_AT',
    'MARKETPLACE',
    'PAID',
    'PRINT_FILES',
    'ALLOW_EXPEDITION',
    'SHIPPER',
    'SHIPPER_SERVICE_CODE',
    'ADDRESS_ID',
    'TRACKING_NUMBER',
    'RETURN_TRACKING_NUMBER',
    'EXCHANGE_TRACKING_NUMBER',
    'ORDER_BOX_COUNT',
    'BRANCH_ID',
    'NOTE',
    'ESHOP_NOTE',
    'TRANSPORT_PAID_BY_SKLADON',
    'UNDER_SANCTION',
    'RECIPIENT_NAME',
    'RECIPIENT_ATTENTION_NAME',
    'RECIPIENT_STREET',
    'RECIPIENT_EMAIL',
    'RECIPIENT_PHONE',
    'RECIPIENT_CITY',
    'RECIPIENT_POST_CODE',
    'RECIPIENT_STATE',
    'RECIPIENT_PROVINCE_CODE',
    'RECIPIENT_ADDRESS_ADDITIONAL_INFO',
    'RECIPIENT_COMPANY_NAME',
    'RECIPIENT_GLN',
    'RECIPIENT_COMPANY_ID',
    'RECIPIENT_TAX_ID',
    'BILLING_NAME',
    'BILLING_ATTENTION_NAME',
    'BILLING_STREET',
    'BILLING_EMAIL',
    'BILLING_PHONE',
    'BILLING_CITY',
    'BILLING_POST_CODE',
    'BILLING_STATE',
    'BILLING_PROVINCE_CODE',
    'BILLING_ADDRESS_ADDITIONAL_INFO',
    'BILLING_COMPANY_NAME',
    'BILLING_GLN',
    'BILLING_COMPANY_ID',
    'BILLING_TAX_ID',
    'PRINT_RETURN_LABEL',
    'HOLD_BY_QUALITY',
    'PICK_FROM_CUSTOMS_WAREHOUSE',
    'ORDER_PRODUCTS',
    'ORDER_PALLETS',
    'FILES',
    'CANCEL_REASON',
    'METHOD',
    'DISABLE_SHIPPING_REORDER',
    'SOURCE_SYS',
    'PREORDER_RELEASE_AT'
];

export type ProductEditKeysType =
    | 'PRODUCT_ID'
    | 'CUSTOMS_PRODUCT_TYPE'
    | 'LOT'
    | 'COUNT'
    | 'PRODUCT_PRICE'
    | 'CUSTOMIZATION_TYPE'
    | 'CUSTOMIZATION_TEXT';

export type PalletEditKeysType = keyof Omit<OrderPalletType, 'ID' | 'ORDER_ID'>;

export const INIT_TAB = 'transport';
export const URL_NEW = '/orders/new';

export const PICKUP_POINT_SERVICE_CODES: readonly string[] = [
    'CPNB',
    'CPNBCOD',
    'DPDPS',
    'GLSPS',
    'GLSSKPS',
    'PPLPP',
    'PPLBOX',
    'PCKT',
];

export const arraySameRecipientBilling = [
    ['RECIPIENT_NAME', 'BILLING_NAME'],
    ['RECIPIENT_ATTENTION_NAME', 'BILLING_ATTENTION_NAME'],
    ['RECIPIENT_STREET', 'BILLING_STREET'],
    ['RECIPIENT_ADDRESS_ADDITIONAL_INFO', 'BILLING_ADDRESS_ADDITIONAL_INFO'],
    ['RECIPIENT_CITY', 'BILLING_CITY'],
    ['RECIPIENT_STATE', 'BILLING_STATE'],
    ['RECIPIENT_PROVINCE_CODE', 'BILLING_PROVINCE_CODE'],
    ['RECIPIENT_POST_CODE', 'BILLING_POST_CODE'],
    ['RECIPIENT_EMAIL', 'BILLING_EMAIL'],
    ['RECIPIENT_PHONE', 'BILLING_PHONE'],
    ['RECIPIENT_COMPANY_NAME', 'BILLING_COMPANY_NAME'],
    ['RECIPIENT_GLN', 'BILLING_GLN']
];

export const historyUpdates: HistoryUpdatesItemType[] = [
    // { key: 'FCN', translateKey: 'orderDetail.fcn' },
    // { key: 'STATUS', translateKey: 'orderDetail.status' },
    // { key: 'ORDER_CAUSE', translateKey: 'orderDetail.orderCause' },
    // { key: 'RESOLVER', translateKey: 'orderDetail.resolver' },
    // { key: 'ORDER_CAUSE_OTHERS_TYPE', translateKey: 'orderDetail.causeOtherTypes' },
    // { key: 'DESCRIPTION', translateKey: 'orderDetail.description' },
    // { key: 'RESOLUTION_TEXT', translateKey: 'orderDetail.resolution' },
    // { key: 'NOTE', translateKey: 'orderDetail.note' },

    { key: 'ESHOP_ORDER_ID', translateKey: 'orderDetail.eshopID' },
    { key: 'ORDER_TYPE', translateKey: 'orderDetail.orderType' },
    { key: 'STATUS', translateKey: 'orderDetail.orderStatus' },
    { key: 'INCORRECT_ORDER_MESSAGE', translateKey: 'orderDetail.incorrectMessage' },
    { key: 'TIMESTAMP', translateKey: 'orderDetail.receivedDate', format: 'date' },
    { key: 'NOTE', translateKey: 'orderDetail.note' },
    { key: 'ESHOP_NOTE', translateKey: 'orderDetail.eshopNote' },
    { key: 'REQUIRED_EXPEDITION_DATE', translateKey: 'orderDetail.requiredExpeditionDate', format: 'onlydate' },
    { key: 'INVOICE_DATE', translateKey: 'orderDetail.invoiceDate', format: 'date' },
    { key: 'INVOICE_NUMBER', translateKey: 'orderDetail.invoiceNumber' },
    { key: 'PAYMENT_METHOD', translateKey: 'orderDetail.paymentMethod' },
    { key: 'PAID', translateKey: 'orderDetail.paid' },
    { key: 'PRINT_FILES', translateKey: 'orderDetail.printFiles' },
    { key: 'DISABLE_SHIPPING_REORDER', translateKey: 'orderDetail.disableShippingReorder' },
    { key: 'ALLOW_EXPEDITION', translateKey: 'orderDetail.allowExpedition' },
    { key: 'PRICE', translateKey: 'orderDetail.invoicePrice', format: 'number' },
    { key: 'CURRENCY', translateKey: 'orderDetail.invoicePriceCurrency' },
    { key: 'SHIPPING_PRICE', translateKey: 'orderDetail.shippingPrice', format: 'number' },
    // { key: 'SHIPPING_CURRENCY', translateKey: 'orderDetail.shippingPriceCurrency' },
    { key: 'COD_PRICE', translateKey: 'orderDetail.cashOnDeliveryPrice', format: 'number' },
    { key: 'COD_CURRENCY', translateKey: 'orderDetail.cashOnDeliveryCurrency' },
    { key: 'COD_REF_NUMBER', translateKey: 'orderDetail.cashOnDeliveryRefNumber' },
    { key: 'SHIPPER', translateKey: 'orderDetail.shipper' },
    { key: 'ADDRESS_ID', translateKey: 'orderDetail.dispensingPoint' },
    { key: 'SHIPPER_SERVICE_CODE', translateKey: 'orderDetail.shipperService' },
    { key: 'TRACKING_NUMBER', translateKey: 'orderDetail.trackingNumber' },
    { key: 'MARKETPLACE', translateKey: 'orderDetail.marketplace' },
    { key: 'RETURN_TRACKING_NUMBER', translateKey: 'orderDetail.returnTrackingNumber' },
    { key: 'EXCHANGE_TRACKING_NUMBER', translateKey: 'orderDetail.exchangeTrackingNumber' },
    { key: 'TRANSPORT_PAID_BY_SKLADON', translateKey: 'orderDetail.transportPaidBySkladon' },
    { key: 'ORDER_BOX_COUNT', translateKey: 'orderDetail.boxCount', format: 'number' },
    { key: 'BRANCH_ID', translateKey: 'orderDetail.branchId' },
    { key: 'SHIPMENT_PENDING', translateKey: 'orderDetail.shipmentPending' },
    { key: 'MESSAGE', translateKey: 'orderDetail.message' },
    { key: 'RECIPIENT_NAME', translateKey: ['orderDetail.history.recipient', 'orderDetail.fullName'] },
    {
        key: 'RECIPIENT_ATTENTION_NAME',
        translateKey: ['orderDetail.history.recipient', 'orderDetail.attentionName']
    },
    { key: 'RECIPIENT_STREET', translateKey: ['orderDetail.history.recipient', 'orderDetail.address'] },
    {
        key: 'RECIPIENT_ADDRESS_ADDITIONAL_INFO',
        translateKey: ['orderDetail.history.recipient', 'orderDetail.addressAdditionalInfo']
    },
    { key: 'RECIPIENT_CITY', translateKey: ['orderDetail.history.recipient', 'orderDetail.city'] },
    { key: 'RECIPIENT_STATE', translateKey: ['orderDetail.history.recipient', 'orderDetail.country'] },
    { key: 'RECIPIENT_PROVINCE_CODE', translateKey: ['orderDetail.history.recipient', 'orderDetail.provinceCode'] },
    { key: 'RECIPIENT_POST_CODE', translateKey: ['orderDetail.history.recipient', 'orderDetail.postCode'] },
    { key: 'RECIPIENT_EMAIL', translateKey: ['orderDetail.history.recipient', 'orderDetail.email'] },
    { key: 'RECIPIENT_PHONE', translateKey: ['orderDetail.history.recipient', 'orderDetail.phone'] },
    { key: 'RECIPIENT_COMPANY_NAME', translateKey: ['orderDetail.history.recipient', 'orderDetail.companyName'] },
    { key: 'RECIPIENT_GLN', translateKey: ['orderDetail.history.recipient', 'orderDetail.GLN'] },
    { key: 'RECIPIENT_COMPANY_ID', translateKey: ['orderDetail.history.recipient', 'orderDetail.companyId'] },
    { key: 'RECIPIENT_TAX_ID', translateKey: ['orderDetail.history.recipient', 'orderDetail.taxId'] },
    { key: 'BILLING_NAME', translateKey: ['orderDetail.history.billing', 'orderDetail.fullName'] },
    { key: 'BILLING_ATTENTION_NAME', translateKey: ['orderDetail.history.billing', 'orderDetail.attentionName'] },
    { key: 'BILLING_STREET', translateKey: ['orderDetail.history.billing', 'orderDetail.address'] },
    {
        key: 'BILLING_ADDRESS_ADDITIONAL_INFO',
        translateKey: ['orderDetail.history.billing', 'orderDetail.addressAdditionalInfo']
    },
    { key: 'BILLING_CITY', translateKey: ['orderDetail.history.billing', 'orderDetail.city'] },
    { key: 'BILLING_STATE', translateKey: ['orderDetail.history.billing', 'orderDetail.country'] },
    { key: 'BILLING_PROVINCE_CODE', translateKey: ['orderDetail.history.billing', 'orderDetail.provinceCode'] },
    { key: 'BILLING_POST_CODE', translateKey: ['orderDetail.history.billing', 'orderDetail.postCode'] },
    { key: 'BILLING_EMAIL', translateKey: ['orderDetail.history.billing', 'orderDetail.email'] },
    { key: 'BILLING_PHONE', translateKey: ['orderDetail.history.billing', 'orderDetail.phone'] },
    { key: 'BILLING_COMPANY_NAME', translateKey: ['orderDetail.history.billing', 'orderDetail.companyName'] },
    { key: 'BILLING_GLN', translateKey: ['orderDetail.history.billing', 'orderDetail.GLN'] },
    { key: 'BILLING_COMPANY_ID', translateKey: ['orderDetail.history.billing', 'orderDetail.companyId'] },
    { key: 'BILLING_TAX_ID', translateKey: ['orderDetail.history.billing', 'orderDetail.taxId'] },
    {
        key: 'RELEASE_FROM_SUSPENDED_AT',
        translateKey: 'orderDetail.releaseFromSuspendedAt',
        format: 'date'
    },
    {
        key: 'PREORDER_RELEASE_AT',
        translateKey: 'orderDetail.preorderReleaseAt',
        format: 'date'
    },
    { key: 'PRINT_RETURN_LABEL', translateKey: 'orderDetail.printReturnLabel' },
    { key: 'HOLD_BY_QUALITY', translateKey: 'orderDetail.holdByQuality' },
    { key: 'PICK_FROM_CUSTOMS_WAREHOUSE', translateKey: 'orderDetail.pickFromCustomsWarehouse' },
    { key: 'CANCEL_REASON', translateKey: 'orderDetail.cancelReason' },
    {
        key: 'IN_PROCESS_AT', translateKey: 'orders.table.inProcessAt', format: 'date'
    },
    {
        key: 'SHIPPED_AT', translateKey: 'orders.table.shippedAt', format: 'date'
    },
    {
        key: 'AT_PICKUP_POINT_AT', translateKey: 'orders.table.atPickupPointAt', format: 'date'
    },
    {
        key: 'WAITING_FOR_CARRIER_AT', translateKey: 'orders.table.waitingForCarrierAt', format: 'date'
    },
    {
        key: 'PACKED_AT', translateKey: 'orders.table.packedAt', format: 'date'
    },
    { key: 'UNDER_SANCTION', translateKey: 'orderDetail.underSanction' },
    { key: 'CANCELED_AT', translateKey: 'orders.table.canceledAt', format: 'date' },
    { key: 'INCORRECT_AT', translateKey: 'orderDetail.history.incorrectAt', format: 'date' },
    { key: 'PROCESSING_AT', translateKey: 'orderDetail.history.processingAt', format: 'date' },
    { key: 'PRODUCTS_NOT_AVAILABLE_AT', translateKey: 'orderDetail.history.productsNotAvailableAt', format: 'date' },
    { key: 'SUSPENDED_AT', translateKey: 'orderDetail.history.suspendedAt', format: 'date' },
    { key: 'WAITING_FOR_PAYMENT_AT', translateKey: 'orderDetail.history.waitingForPaymentAt', format: 'date' },
    { key: 'WAITING_FOR_SHIPMENT_AT', translateKey: 'orders.table.waitingForShipmentAt', format: 'date' },
    { key: 'RETURNING_BACK_AT', translateKey: 'orders.table.returningBackAt', format: 'date' },
    { key: 'RETURNED_BACK_AT', translateKey: 'orders.table.returnedBackAt', format: 'date' },
    { key: 'DELIVERED_AT', translateKey: 'orders.table.deliveredAt', format: 'date' },
    { key: 'SHIPMENT_ORDERED_AT', translateKey: 'orders.table.shipmentOrderAt', format: 'date' },
    { key: 'METHOD', translateKey: 'orders.table.method' },
    { key: 'SOURCE_SYS', translateKey: 'orders.table.sourceSys' },
    { key: 'MESSAGE_ON_EXPEDITION_BOX', translateKey: 'orderDetail.messageOnExpeditionBox' },
    { key: 'WEIGHT', translateKey: 'orders.table.weight', format: 'number' },
    { key: 'UNIT', translateKey: 'orderDetail.history.unit' },
    { key: 'ORDER_DATE', translateKey: 'orderDetail.history.orderDate', format: 'onlydate' },
    { key: 'SUB_STATUS', translateKey: 'orderDetail.history.subStatus' },
    { key: 'SLA_DATE', translateKey: 'orders.table.slaDate', format: 'date' },
];

export const historyUpdatesSkladonUser: HistoryUpdatesItemType[] = [
    ...historyUpdates,
    { key: 'SHIPPER_ZONE', translateKey: 'orderDetail.history.shipperZone', format: 'number' },
    { key: 'SHIPPER_LABEL_PRINTED', translateKey: 'orderDetail.history.shipperLabelPrinted' },
    { key: 'SCANNED_AT', translateKey: 'orders.table.scannedAt', format: 'date' },
    { key: 'DCIX_EXPORT', translateKey: 'orderDetail.history.dcixExport', format: 'date' },
    { key: 'DELIVERED_HOOK', translateKey: 'orderDetail.history.deliveredHook' },
    { key: 'PARENT_ORDER_ID', translateKey: 'orders.table.parentOrderId', format: 'number' },
    { key: 'PARENT_ESHOP_ORDER_ID', translateKey: 'orders.table.parentEshopId' },
    { key: 'PARTNER_ORDER_ID', translateKey: 'orders.table.partnerOrderId' },
    { key: 'ESHOP_KEY', translateKey: 'providerDetail.eshopKey' },
];

/** Keys never shown for CREATE history entries (still shown on EDIT). */
export const historyCreateHiddenKeys: string[] = ['METHOD', 'ORDER_DATE', 'ESHOP_KEY'];

export const  historyProductUpdates: HistoryUpdatesItemType[] = [
    { key: 'PRODUCT.NAME', translateKey: 'orderDetail.productTable.name' },
    { key: 'PRODUCT.SKU', translateKey: 'orderDetail.productTable.SKU' },
    // { key: 'SKU', translateKey: 'orderDetail.productTable.SKU' },
    { key: 'COUNT', translateKey: 'orderDetail.productTable.count', format: 'number' },
    { key: 'MISSING_COUNT', translateKey: 'orderDetail.productTable.missingCount', format: 'number' },
    { key: 'PRODUCT_PRICE', translateKey: 'orderDetail.productTable.price', format: 'number' },
    // { key: 'PRODUCT_CURRENCY', translateKey:  'orderDetail.productTable.currency'},
    { key: 'CONFIRMED', translateKey: 'orderDetail.productTable.confirmed', format: 'number' },
    { key: 'LINE_STATE', translateKey: 'orderDetail.productTable.lineState' },
    { key: 'LOT', translateKey: 'orderDetail.productTable.lot' },
    { key: 'CUSTOMS_PRODUCT_TYPE', translateKey: 'orderDetail.productTable.customsProductType' },
    { key: 'CUSTOMIZATION_TYPE', translateKey: 'orderDetail.productTable.customizationType' },
    { key: 'CUSTOMIZATION_TEXT', translateKey: 'orderDetail.productTable.customizationText' },
    { key: 'BCX_CODE', translateKey: 'orderDetail.productTable.bcxCode'}
];

export const historyProductSetsUpdates: HistoryUpdatesItemType[] = [
    // { key: 'SET_SKU', translateKey: 'orderDetail.history.SET_SKU' },
    { key: 'COUNT', translateKey: 'orderDetail.productTable.count', format: 'number' },
    { key: 'LINE_STATE', translateKey: 'orderDetail.productTable.lineState' },
    { key: 'PRODUCT_PRICE', translateKey: 'orderDetail.productTable.price', format: 'number' },
    { key: 'ORDER_PRODUCTS', translateKey: 'orderDetail.productTable.orderProducts' }
];

export const historyOrderFileUpdates: HistoryUpdatesItemType[] = [
    { key: 'FILE.ORIGINAL_FILE_NAME', translateKey: 'orderDetail.history.fileName' },
    { key: 'FILE.FILE_TYPE', translateKey: 'orderDetail.history.fileType' },
    { key: 'FILE.TYPE', translateKey: 'orderDetail.history.fileCategory' }
];

export const historyOrderProductFileUpdates: HistoryUpdatesItemType[] = [
    { key: 'PRODUCT.NAME', translateKey: 'orderDetail.productTable.name' },
    { key: 'PRODUCT.SKU', translateKey: 'orderDetail.productTable.SKU' },
    { key: 'FILE.ORIGINAL_FILE_NAME', translateKey: 'orderDetail.history.fileName' },
    { key: 'FILE.FILE_TYPE', translateKey: 'orderDetail.history.fileType' },
    { key: 'FILE.TYPE', translateKey: 'orderDetail.history.fileCategory' }
];

export const historyOrderPalletUpdates: HistoryUpdatesItemType[] = [
    { key: 'PALLET_TYPE', translateKey: 'orderDetail.palletTable.palletType' },
    { key: 'HEIGHT', translateKey: 'orderDetail.palletTable.height', format: 'number' },
    { key: 'WIDTH', translateKey: 'orderDetail.palletTable.width', format: 'number' },
    { key: 'LENGTH', translateKey: 'orderDetail.palletTable.length', format: 'number' },
    { key: 'WEIGHT', translateKey: 'orderDetail.palletTable.weight', format: 'number' }
];

// SLA calculation attributes - different sets for different action types
// These will be filtered based on the SLA reason in HistoryBlock

// All possible SLA attributes (used as fallback)
export const historySlaCalculationUpdates: HistoryUpdatesItemType[] = [
    { key: 'SLA_CALCULATION.input.orderTimestamp', translateKey: 'orderDetail.slaCalculation.input.orderTimestamp', format: 'date' },
    { key: 'SLA_CALCULATION.input.requiredExpeditionDate', translateKey: 'orderDetail.slaCalculation.input.requiredExpeditionDate', format: 'date' },
    { key: 'SLA_CALCULATION.input.suspendedAt', translateKey: 'orderDetail.slaCalculation.input.suspendedAt', format: 'date' },
    { key: 'SLA_CALCULATION.input.waitingForPaymentAt', translateKey: 'orderDetail.slaCalculation.input.waitingForPaymentAt', format: 'date' },
    { key: 'SLA_CALCULATION.input.productsNotAvailableAt', translateKey: 'orderDetail.slaCalculation.input.productsNotAvailableAt', format: 'date' },
    { key: 'SLA_CALCULATION.input.incorrectAt', translateKey: 'orderDetail.slaCalculation.input.incorrectAt', format: 'date' },
    { key: 'SLA_CALCULATION.input.orderType', translateKey: 'orderDetail.slaCalculation.input.orderType' },
    { key: 'SLA_CALCULATION.input.shipper', translateKey: 'orderDetail.slaCalculation.input.shipper' },
    { key: 'SLA_CALCULATION.input.carrierCot', translateKey: 'orderDetail.slaCalculation.input.carrierCot' },
    { key: 'SLA_CALCULATION.input.providerCot', translateKey: 'orderDetail.slaCalculation.input.providerCot' },
    { key: 'SLA_CALCULATION.calculation.isBeforeCutTime', translateKey: 'orderDetail.slaCalculation.calculation.isBeforeCutTime' },
    { key: 'SLA_CALCULATION.input.productsCount', translateKey: 'orderDetail.slaCalculation.input.productsCount' },
    { key: 'SLA_CALCULATION.input.b2bD0', translateKey: 'orderDetail.slaCalculation.input.b2bD0' },
    { key: 'SLA_CALCULATION.input.b2bD1', translateKey: 'orderDetail.slaCalculation.input.b2bD1' },
    { key: 'SLA_CALCULATION.input.b2bD2', translateKey: 'orderDetail.slaCalculation.input.b2bD2' },
    { key: 'SLA_CALCULATION.input.b2bD3', translateKey: 'orderDetail.slaCalculation.input.b2bD3' },
    { key: 'SLA_CALCULATION.calculation.nextWorkingDate', translateKey: 'orderDetail.slaCalculation.calculation.nextWorkingDate', format: 'date' },
    { key: 'SLA_CALCULATION.calculation.baseDate', translateKey: 'orderDetail.slaCalculation.calculation.baseDate', format: 'date' },
    { key: 'SLA_CALCULATION.result', translateKey: 'orderDetail.slaCalculation.result', format: 'date' },
    { key: 'SLA_CALCULATION.previousSlaDate', translateKey: 'orderDetail.slaCalculation.previousSlaDate', format: 'date' },
    { key: 'SLA_CALCULATION.input.postponeDays', translateKey: 'orderDetail.slaCalculation.input.postponeDays' },
    // { key: 'SLA_CALCULATION.calculation.isHolidayOrWeekend', translateKey: 'orderDetail.slaCalculation.calculation.isHolidayOrWeekend' }
];

// Keys to show for each SLA reason type
export const slaReasonAttributeKeys: Record<string, string[]> = {
    // Manual postpone - just show old/new SLA and days
    'manual_postpone': [
        'SLA_CALCULATION.result',
        'SLA_CALCULATION.previousSlaDate',
        'SLA_CALCULATION.input.postponeDays'
    ],
    // Customs delay - similar to manual postpone
    'customs_delay': [
        'SLA_CALCULATION.result',
        'SLA_CALCULATION.previousSlaDate',
        'SLA_CALCULATION.input.postponeDays'
    ],
    // Nullification - just show that SLA was nullified
    'status_change_to_suspended': [
        'SLA_CALCULATION.result',
        'SLA_CALCULATION.previousSlaDate'
    ],
    'status_change_to_preorder': [
        'SLA_CALCULATION.result',
        'SLA_CALCULATION.previousSlaDate'
    ],
    // Shipment ordered - full calculation details (productsCount only for B2B, handled in code)
    'shipment_ordered': [
        'SLA_CALCULATION.input.orderTimestamp',
        'SLA_CALCULATION.input.requiredExpeditionDate',
        'SLA_CALCULATION.input.suspendedAt',
        'SLA_CALCULATION.input.waitingForPaymentAt',
        'SLA_CALCULATION.input.productsNotAvailableAt',
        'SLA_CALCULATION.input.incorrectAt',
        'SLA_CALCULATION.input.orderType',
        'SLA_CALCULATION.input.shipper',
        'SLA_CALCULATION.input.carrierCot',
        'SLA_CALCULATION.input.providerCot',
        'SLA_CALCULATION.calculation.isBeforeCutTime',
        'SLA_CALCULATION.input.productsCount', // Will be filtered out for B2C in code
        'SLA_CALCULATION.input.b2bD0', // B2B only
        'SLA_CALCULATION.input.b2bD1', // B2B only
        'SLA_CALCULATION.input.b2bD2', // B2B only
        'SLA_CALCULATION.input.b2bD3', // B2B only,
        'SLA_CALCULATION.calculation.nextWorkingDate',
        'SLA_CALCULATION.calculation.baseDate',
        'SLA_CALCULATION.result',
        'SLA_CALCULATION.calculation.isHolidayOrWeekend'
    ],
    // Status change to received - similar to shipment ordered
    'status_change_to_received': [
        'SLA_CALCULATION.input.orderTimestamp',
        'SLA_CALCULATION.input.requiredExpeditionDate',
        'SLA_CALCULATION.input.suspendedAt',
        'SLA_CALCULATION.input.waitingForPaymentAt',
        'SLA_CALCULATION.input.productsNotAvailableAt',
        'SLA_CALCULATION.input.incorrectAt',
        'SLA_CALCULATION.input.orderType',
        'SLA_CALCULATION.input.shipper',
        'SLA_CALCULATION.input.carrierCot',
        'SLA_CALCULATION.input.providerCot',
        'SLA_CALCULATION.calculation.isBeforeCutTime',
        'SLA_CALCULATION.input.productsCount',
        'SLA_CALCULATION.input.b2bD0',
        'SLA_CALCULATION.input.b2bD1',
        'SLA_CALCULATION.input.b2bD2',
        'SLA_CALCULATION.input.b2bD3',
        'SLA_CALCULATION.calculation.nextWorkingDate',
        'SLA_CALCULATION.calculation.baseDate',
        'SLA_CALCULATION.result',
    ],
    // Products available - recalculation
    'products_available': [
        'SLA_CALCULATION.input.orderTimestamp',
        'SLA_CALCULATION.input.requiredExpeditionDate',
        'SLA_CALCULATION.input.suspendedAt',
        'SLA_CALCULATION.input.waitingForPaymentAt',
        'SLA_CALCULATION.input.productsNotAvailableAt',
        'SLA_CALCULATION.input.incorrectAt',
        'SLA_CALCULATION.input.orderType',
        'SLA_CALCULATION.input.shipper',
        'SLA_CALCULATION.input.carrierCot',
        'SLA_CALCULATION.input.providerCot',
        'SLA_CALCULATION.calculation.isBeforeCutTime',
        'SLA_CALCULATION.input.productsCount',
        'SLA_CALCULATION.input.b2bD0',
        'SLA_CALCULATION.input.b2bD1',
        'SLA_CALCULATION.input.b2bD2',
        'SLA_CALCULATION.input.b2bD3',
        'SLA_CALCULATION.calculation.nextWorkingDate',
        'SLA_CALCULATION.calculation.baseDate',
        'SLA_CALCULATION.result',
        'SLA_CALCULATION.input.productsCount'
    ],
    // Shipper change
    'shipper_change': [
        'SLA_CALCULATION.input.orderTimestamp',
        'SLA_CALCULATION.input.requiredExpeditionDate',
        'SLA_CALCULATION.input.suspendedAt',
        'SLA_CALCULATION.input.waitingForPaymentAt',
        'SLA_CALCULATION.input.productsNotAvailableAt',
        'SLA_CALCULATION.input.incorrectAt',
        'SLA_CALCULATION.input.orderType',
        'SLA_CALCULATION.input.shipper',
        'SLA_CALCULATION.input.carrierCot',
        'SLA_CALCULATION.input.providerCot',
        'SLA_CALCULATION.calculation.isBeforeCutTime',
        'SLA_CALCULATION.calculation.nextWorkingDate',
        'SLA_CALCULATION.calculation.baseDate',
        'SLA_CALCULATION.result',
        'SLA_CALCULATION.previousSlaDate'
    ],
    // Required expedition date change
    'required_expedition_change': [
        'SLA_CALCULATION.result',
        'SLA_CALCULATION.previousSlaDate',
        'SLA_CALCULATION.input.requiredExpeditionDate'
    ]
};

export const progressStepsCreate: { label: string; key: string }[] = [
    { label: translate('orderDetail.tab.invoiceTransport'), key: 'transport' },
    { label: translate('orderDetail.tab.address'), key: 'address' },
    { label: translate('orderDetail.tab.products'), key: 'products' },
    { label: translate('orderDetail.tab.summary'), key: 'summary' }
];
export const progressSteps: { label: string; value: string }[] = [
    { value: 'transport', label: translate('orderDetail.tab.transport') },
    { value: 'address', label: translate('orderDetail.tab.address') },
    { value: 'products', label: translate('orderDetail.tab.products') },
    { value: 'pallets', label: translate('orderDetail.tab.pallets') },
    { value: 'claimsReturns', label: translate('orderDetail.tab.claimsReturns') },
    { value: 'transports', label: translate('orderDetail.tab.transports') },
    { value: 'expeditionPackages', label: translate('orderDetail.tab.expeditionPackages') },
    { value: 'history', label: translate('orderDetail.tab.history') },
    { value: 'transportHistory', label: translate('orderDetail.tab.transportHistory') }
];

export const productsDefaultColumns: TableColumnType[] = [
    {
        key: 'PRODUCT_ID',
        label: 'id',
        type: 'id',
        defaultShow: true,
    },
    {
        key: 'SKU',
        label: 'SKU',
        defaultShow: true,
    },
    {
        key: 'NAME',
        label: 'name',
        customRender: true,
        defaultShow: true,
    },
    {
        key: 'EAN',
        label: 'EAN',
        defaultShow: true,
    },
    {
        key: 'PRODUCT_TYPE',
        label: 'productType',
        type: 'select',
        selectOption: 'productTypeCodes',
        defaultShow: true,
        optionStyleFce: true,
    },
    {
        key: 'COUNT',
        label: 'count',
        type: 'number-filter',
        customRender: true,
        customStyle: { width: '1%', minWidth: '130px' },
        customStyleHeader: { width: '1%', minWidth: '130px' },
        defaultShow: true,
    },
    {
        key: 'MISSING_COUNT',
        label: 'missingCount',
        type: 'number-filter',
        customRender: true,
        defaultShow: true,
    },
    {
        key: 'CONFIRMED',
        label: 'confirmed',
        type: 'number-filter',
        defaultShow: true,
    },
    {
        key: 'SERIAL_NUMBER',
        label: 'serialNumber',
        defaultShow: true,
    },
    {
        key: 'PRODUCT_PRICE',
        label: 'price',
        type: 'number-filter',
        customRender: true,
        defaultShow: true,
    },
    {
        key: 'TOTAL_PRICE',
        label: 'totalPrice',
        type: 'number-filter',
        customRender: true,
        defaultShow: true,
    },
    {
        key: 'WEIGHT',
        label: 'weight',
        type: 'number-filter',
        defaultShow: true,
    },
    {
        key: 'HS_CODE',
        label: 'hsCode',
        defaultShow: true,
    },
    {
        key: 'CUSTOMIZATION_TYPE',
        label: 'customizationType',
        type: 'select',
        selectOption: 'orderProductCustomizationType',
        defaultShow: false,
    },
    {
        key: 'AGECHECK',
        label: 'agecheck',
        type: 'select',
        selectOption: 'boolNumberCodes',
        defaultShow: false,
    },
    {
        key: 'DESCRIPTION',
        label: 'description',
        defaultShow: false,
    },
    {
        key: 'EXP_METHOD',
        label: 'expeditionMethod',
        type: 'select',
        selectOption: 'expeditionMethodCodes',
        defaultShow: false,
    },
    {
        key: 'INSERT_TYPE',
        label: 'insertType',
        type: 'select',
        selectOption: 'productInsetTypeCodes',
        defaultShow: false,
    },
    {
        key: 'ROP',
        label: 'ROP',
        type: 'number-filter',
        defaultShow: false,
    },
    {
        key: 'EXPIRATION_DAYS',
        label: 'EXPIRATION_DAYS',
        type: 'number-filter',
        defaultShow: false,
    },
    {
        key: 'SCAN_IMEI_SN_TYPE',
        label: 'scanSerialNumber',
        type: 'select',
        selectOption: 'scanImeiSnCodes',
        defaultShow: false,
    },
    {
        key: 'SN_REGEX',
        label: 'snRegex',
        defaultShow: false,
    },
    {
        key: 'WIDTH',
        label: 'width',
        type: 'number-filter',
        defaultShow: false,
    },
    {
        key: 'HEIGHT',
        label: 'height',
        type: 'number-filter',
        defaultShow: false,
    },
    {
        key: 'LENGTH',
        label: 'length',
        type: 'number-filter',
        defaultShow: false,
    },
    {
        key: 'PRICE',
        label: 'catalogPrice',
        type: 'number-filter',
        defaultShow: false,
    },
    {
        key: 'UNIT_PRICE',
        label: 'unitPrice',
        type: 'select',
        selectOption: 'currencyCodes',
        defaultShow: false,
    },
    {
        key: 'BATTERY_TYPE',
        label: 'batteryType',
        type: 'select',
        selectOption: 'batteryTypeCodes',
        defaultShow: false,
    },
    {
        key: 'CUSTOM_FIELD_1',
        label: 'customField1',
        defaultShow: false,
    },
    {
        key: 'CUSTOM_FIELD_2',
        label: 'customField2',
        defaultShow: false,
    },
    {
        key: 'CUSTOM_FIELD_3',
        label: 'customField3',
        defaultShow: false,
    },
    {
        key: 'ACTIVE',
        label: 'active',
        type: 'select',
        selectOption: 'boolNumberCodes',
        defaultShow: false,
    },
    {
        key: 'CREATED_AT',
        label: 'createdAt',
        type: 'dateTime',
        defaultShow: false,
    },
    {
        key: 'UPDATED_AT',
        label: 'updatedAt',
        type: 'dateTime',
        defaultShow: false,
    },
    {
        key: 'IS_DELETED',
        label: 'isDeleted',
        type: 'select',
        selectOption: 'boolNumberCodes',
        defaultShow: false,
    },
    {
        key: 'DELETED_AT',
        label: 'deletedAt',
        type: 'dateTime',
        defaultShow: false,
    },
];

export const expeditionPackagesAllColumns: TableColumnType[] = [
    {
        key: 'ID',
        label: 'id',
    },
    {
        key: 'EXP_PCKG',
        label: 'expeditionPackage'
    },
    {
        key: 'WIDTH',
        label: 'width',
        type: 'number-filter'
    },
    {
        key: 'HEIGHT',
        label: 'height',
        type: 'number-filter'
    },
    {
        key: 'LENGTH',
        label: 'length',
        type: 'number-filter'
    },
    {
        key: 'WEIGHT',
        label: 'weight',
        type: 'number-filter'
    },
    {
        key: 'TRACKING_NUMBER',
        label: 'trackingNumber'
    },
    {
        key: 'PCKG_SKU',
        label: 'packageSku'
    },
    {
        key: 'EXP_PAL',
        label: 'expPal'
    },
    {
        key: 'PALLET_SKU',
        label: 'palletSku'
    },
    {
        key: 'product_SKU',
        label: 'productSKU'
    },
    {
        key: 'product_NAME',
        label: 'productName',
    },
    {
        key: 'product_EAN',
        label: 'productEan'
    },
    {
        key: 'product_COUNT',
        label: 'productCount'
    },
    {
        key: 'product_SERIAL_NUMBER',
        label: 'serialNumber'
    },
    {
        key: 'product_LOT',
        label: 'productLot'
    },
    {
        key: 'product_EXP_DATE',
        label: 'productExpDate'
    },
    {
        key: 'SSCC_NUMBER',
        label: 'sscc'
    },
];

export const orderTransportsAllColumns: TableColumnType[] = [
    { key: 'ID', label: 'id' },
    { key: 'ROLE', label: 'role' },
    { key: 'STATUS', label: 'status', customRender: true },
    { key: 'TRACKING_NUMBER', label: 'trackingNumber' },
    { key: 'SHIPPER', label: 'shipper' },
];

export const claimsReturnsAllColumns: TableColumnType[] = [
    { key: 'type', label: 'type', type: 'select', selectOption: 'orderClaimReturnTypeCodes' },
    { key: 'ID', label: 'id' },
    { key: 'ESHOP_ID', label: 'eshopId' },
    { key: 'typeKey', label: 'typeKey' },
    { key: 'CREATED_AT', label: 'createdAt', type: 'dateTime' },
    { key: 'STATUS', label: 'status', customRender: true },
    { key: 'SHIPPER', label: 'shipper' },
    { key: 'TRACKING_NUMBER', label: 'trackingNumber' }
];

export const STORAGE_KEY = 'orderEditData';

export const SHIPPER_FILE_TYPES = ['shipResponse', 'shipReturnResponse', 'shipSwapResponse'];

